export default __webpack_public_path__ + "a1d86a2688c1e756a183f55045666822.png";